import { render, staticRenderFns } from "./AssetRegistryNav.vue?vue&type=template&id=7a3a9da6&scoped=true&"
import script from "./AssetRegistryNav.vue?vue&type=script&lang=js&"
export * from "./AssetRegistryNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a9da6",
  null
  
)

export default component.exports